import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useContext } from 'react'
import { ThemeContext } from './contexts/theme'
import { LanguageProvider } from './contexts/language'
import Header from './components/Header/Header'
import About from './components/About/About'
import Projects from './components/Projects/Projects'
import Skills from './components/Skills/Skills'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Contact from './components/Contact/Contact'
import Footer from './components/Footer/Footer'
import Impressum from './components/Impressum/Impressum'
// import Blog from './components/Blog/Blog'
// import BlogDetail from './components/Blog/BlogDetail'
import './App.css'

const App = () => {
  const [{ themeName }] = useContext(ThemeContext)

  return (
    <LanguageProvider>
      <Router>
        <div id='top' className={`${themeName} app`}>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={
                <>
                  <About />
                  <Projects />
                  <Skills />
                  <Contact />
                </>
              } />
              <Route path="/impressum" element={<Impressum />} />
              {/* Blog routes temporarily disabled - work in progress
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              */}
            </Routes>
          </main>
          <ScrollToTop />
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  )
}

export default App
